module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/images/shape_pattern.2f3c0a60.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/images/shape_pattern.png
// module id = 1318
// module chunks = 16